// extracted by mini-css-extract-plugin
export default {"wrapper":"tabs_wrapper__Fhp09","label":"tabs_label__ZXHR7","greyBg":"tabs_greyBg__YYO-b","darkBg":"tabs_darkBg__UxUbK","active":"tabs_active__Bnc15"};